/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

const DEFAULT_PARAMS = { "filter[active_only]": 1, "filter[count]": 1, include: "membership.services" };

export const useGetPurchasedMemberships = (params = {}, queryOptions = {}) => {
  const finalParams = { ...DEFAULT_PARAMS, ...params };

  return useQuery({
    queryKey: queryKeys.purchasedMemberships.list(finalParams),
    queryFn: async () => {
      return await fetcher({
        method: "GET",
        url: "/public/memberships/purchased",
        params: finalParams,
      });
    },
    ...queryOptions,
  });
};
